export class TypeOperation {
  typeOperationId: number;
  nom: string;
  siteId: number;
}
